import {Select, Typography} from '@material-ui/core';
import {useTranslation} from "react-i18next";

export const FieldSelect = selectProps => {
    const {t: translate} = useTranslation();
    const {onValueChange, ...restSelectProps} = selectProps;
    const handleChange = onValueChange
            ? (changeEvent) => {
                selectProps.field.onChange(changeEvent);
                onValueChange(changeEvent);
            }
            : undefined;
    return <Select {...restSelectProps}
            {...restSelectProps?.field}
            {...(handleChange && {onChange: handleChange})}
            value={restSelectProps?.field?.value || ''}
            renderValue={restSelectProps?.field?.value
                    ? undefined
                    : () => <Typography style={{color: '#d7d7d7'}}>
                        {translate('anamnesis.selectNotification')}
                    </Typography>}
    />
}

export const PlaceholderOrValue = (value, t) => {
    return value
            ? undefined
            : () => <Typography style={{color: '#d7d7d7'}}>
                {t('anamnesis.selectNotification')}
            </Typography>
}

export default FieldSelect;
